<template>
  <div id="app">
    <div v-if="loading" class="d-flex justify-content-center">
      <div
        class="spinner-border"
        style="width: 3rem; height: 3rem;"
        role="status"
      ></div>
    </div>
    <router-view v-else-if="!error" />
    <div v-else>
      <div class="alert alert-danger" role="alert">
        {{ $t("error.configurationRetrieval") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    error: false
  }),
  mounted() {
    this.$store
      .dispatch("view/get")
      .then(() => {
        this.loading = false;
      })
      .catch(err => {
        console.log("An error occured", err);
        this.loading = false;
        this.error = true;
      });
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
